import { useEffect, useState } from 'react'
import smoothscroll from 'smoothscroll-polyfill'
import cn from 'classnames'

import { spyBarScrollIntersectionObserver } from 'utils/spyBarScrollIntersectionObserver'

export const SpySidebar = ({ settings, root }) => {
  const [selectedSection, setSelectedSection] = useState(
    settings[0].ref
  )
  const sectionClasses = (ref) =>
    cn('item-spy-sidebar__element', {
      '-active': ref === selectedSection,
    })

  const scrollToSection = (ref, text) => () => {
    const section = document.getElementById(text)

    if (section) {
      ref.current.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      })

      smoothscroll.polyfill()
    }
  }

  const scrollObserver = spyBarScrollIntersectionObserver(
    root,
    settings,
    setSelectedSection
  )

  const sections = settings
    ?.map(({ ref }) => ref?.current ?? null)
    ?.filter((section) => section !== null)

  useEffect(() => {
    if (sections) {
      sections?.forEach((section) => scrollObserver.observe(section))
    }

    return () => scrollObserver.disconnect()
    // eslint-disable-next-line
  }, [sections.length])

  return (
    <div className="item-spy-sidebar">
      <p className="item-spy-sidebar__title">Sections</p>
      <ul className="item-spy-sidebar__list">
        {settings.map(({ text, ref }) => (
          <li
            key={text}
            className={sectionClasses(ref)}
            onClick={scrollToSection(ref, text)}
          >
            {text}
          </li>
        ))}
      </ul>
    </div>
  )
}
